import './ErrorMessage.css';

export function ErrorMessage({
  message,
  title = 'Error',
  onRetry,
  variant = 'error'
}) {
  return (
    <div className={`error-message error-message--${variant}`} role="alert">
      <div className="error-message-header">
        <svg
          className="error-message-icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
        <h3 className="error-message-title">{title}</h3>
      </div>
      <p className="error-message-text">{message}</p>
      {onRetry && (
        <button className="error-message-retry" onClick={onRetry}>
          Try Again
        </button>
      )}
    </div>
  );
}

export default ErrorMessage;